/**
 * Valid cross-border interconnector combinations
 * Generated by scripts/discover_crossborder_interconnectors.py
 * Generated: 2026-02-11T12:00:14.661232
 *
 * This mapping defines which country pairs have actual interconnector data.
 * Empty combinations are excluded to avoid creating empty charts.
 */
export const VALID_INTERCONNECTORS = {
  AT: ['CH', 'CZ', 'DE', 'HU', 'IT', 'SI'],
  BA: ['HR', 'ME', 'RS'],
  BE: ['DE', 'FR', 'LU', 'NL', 'UK'],
  BG: ['GR', 'MK', 'RO', 'RS'],
  CH: ['AT', 'DE', 'FR', 'IT'],
  CZ: ['AT', 'DE', 'PL', 'SK'],
  DE: ['AT', 'BE', 'CH', 'CZ', 'DK', 'FR', 'LU', 'NL', 'NO', 'PL', 'SE'],
  DK: ['DE', 'NL', 'NO', 'SE'],
  EE: ['FI', 'LV'],
  ES: ['FR', 'PT'],
  FI: ['EE', 'NO', 'SE'],
  FR: ['BE', 'CH', 'DE', 'ES', 'IT', 'LU', 'UK'],
  GR: ['BG', 'IT', 'MK'],
  HR: ['BA', 'HU', 'RS', 'SI'],
  HU: ['AT', 'HR', 'RO', 'RS', 'SK', 'UA'],
  IE: ['UK'],
  IT: ['AT', 'CH', 'FR', 'GR', 'MT', 'SI'],
  LT: ['LV', 'PL', 'SE'],
  LU: ['BE', 'DE', 'FR'],
  LV: ['EE', 'LT'],
  ME: ['BA', 'RS'],
  MK: ['BG', 'GR', 'RS'],
  MT: ['IT'],
  NL: ['BE', 'DE', 'DK', 'NO', 'UK'],
  NO: ['DE', 'DK', 'FI', 'NL', 'SE', 'UK'],
  PL: ['CZ', 'DE', 'LT', 'SE', 'SK', 'UA'],
  PT: ['ES'],
  RO: ['BG', 'HU', 'RS', 'UA'],
  RS: ['BA', 'BG', 'HR', 'HU', 'ME', 'MK', 'RO'],
  SE: ['DE', 'DK', 'FI', 'LT', 'NO', 'PL'],
  SI: ['AT', 'HR', 'IT'],
  SK: ['CZ', 'HU', 'PL', 'UA'],
  UK: ['BE', 'FR', 'NL', 'NO'],
};

/**
 * Get valid border countries for a home country
 * @param {string} homeCountry - The home country code
 * @returns {string[]} Array of valid border country codes
 */
export const getValidBorderCountries = (homeCountry) => {
  return VALID_INTERCONNECTORS[homeCountry] || [];
};
